<template>
  <div class="filters">
    <div class="filters__wrap">
      <ul class="filters__list">
        <div v-for="(value, key) in filters" :key="key">
          <SingleFilter :filter="value" :title="key" />
        </div>

        <!-- <SingleFilter :filter="{ name: 'radius' }" /> -->

        <!-- <svg class="filters__btn">
          <use xlink:href="#sliders-h-regular"></use>
        </svg> -->
        <li
          @click="clearFilter"
          class="filters__clear"
          :class="{ activeClass: isSelected }"
        >
          Clear Filters
        </li>
        <div @click="setIsMapOpen" class="filter__map">
          <svg>
            <use :xlink:href="isMapOpen ? '#list-light' : '#map-light'"></use>
          </svg>
          {{ isMapOpen ? "List" : "Map" }}
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SingleFilter from "./SingleFilter.vue";
export default {
  name: "Filters",
  data() {
    return {
      isMapOpen: false,
    };
  },
  components: { SingleFilter },
  computed: {
    ...mapState("products", ["filters", "isSelected"]),
  },
  methods: {
    clearFilter() {
      if (this.isSelected) {
        let link = window.location;
        let kw = link.search.split("&").filter((item) => item.includes("kw="));
        window.location.href = `${link.origin}${link.pathname}?${kw?.[0]}`;
      }
    },
    setIsMapOpen() {
      const cols = document.querySelectorAll(".jsCategoryCol");
      cols.forEach((item) => {
        item.classList.toggle("active");
      });
      this.isMapOpen = !this.isMapOpen;
    },
  },
};
</script>
